import type { Order } from '../types';
import { isSampleOrDemoOrderId } from './sampleOrderIds';
import { isUnpaidOnlineWebOrder } from './onlineOrderVisibility';
import { orderHasMeaningfulItems } from './orderUtils';

/**
 * Unpaid tickets that belong in Pending Order Revenue and the POS Pending queue.
 * Excludes: demo/seed data, soft-deleted rows, unpaid online checkout drafts (customer
 * still paying on their phone), and empty ghost tickets with no real line items.
 */
export function isOpenUnpaidOrder(order: Order): boolean {
  if (order.paymentStatus !== 'unpaid') return false;
  if (order.isDeleted) return false;
  if (order.status === 'cancelled' || order.status === 'refunded' || order.status === 'comped') return false;
  if (order.isComped) return false;
  if (isSampleOrDemoOrderId(String(order.id))) return false;
  if (isUnpaidOnlineWebOrder(order)) return false;
  if (!orderHasMeaningfulItems(order)) return false;
  return true;
}
